import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { AvailabilityEditor } from '@ps-design-system/components/calendar/AvailabilityEditor';
import { injectIntl, intlShape } from 'react-intl';
import { updateConfirmAvailModalShown } from './util/availability-cookie-util';

const CalendarAvailabilityModal = ({
  dates,
  onDismiss,
  onConfirm,
  intl,
  profileSSOid
}) => {
  useEffect(() => {
    updateConfirmAvailModalShown(profileSSOid);
    analytics.track('viewed_availability_modal', { ssoId: profileSSOid });
  }, []);

  const handleClose = () => {
    analytics.track('clicked_dismiss_availability_modal', { ssoId: profileSSOid });
    onDismiss();
  };

  const handleViewCalendar = () => {
    analytics.track('clicked_view_calendar_availability_modal', { ssoId: profileSSOid });
    onDismiss();
  };

  const handleConfirm = () => {
    analytics.track('clicked_confirm_availability_modal', { ssoId: profileSSOid });
    onConfirm();
  };

  return (
    <BootstrapModal
      showModal={true}
      onClose={handleClose}
      modalSize="sm-size"
      modalClass="basic-modal"
      title={''}
      body={
        <AvailabilityEditor
          intl={intl}
          dateBlocks={dates}
          onConfirmPressed={handleConfirm}
          onViewCalendarPressed={handleViewCalendar}
          timeZone={'UTC'}
        />
      }
    />
  );
};

CalendarAvailabilityModal.propTypes = {
  dates: PropTypes.array.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  bypassDisplayTimer: PropTypes.bool,
  intl: intlShape.isRequired,
  profileSSOid: PropTypes.string.isRequired
};

export default injectIntl(CalendarAvailabilityModal);
